import { index, pgTable, text, timestamp, unique, uuid, varchar } from "drizzle-orm/pg-core"
import { partnerNameEnum } from "./partner-mapping"
import { users } from "./users"

// Login authority is deliberately separate from mutable partner sync bookkeeping.
export const externalUserLinks = pgTable(
  "external_user_link",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    partnerName: partnerNameEnum("partner_name").notNull(),
    externalId: text("external_id").notNull(),
    userId: varchar("user_id", { length: 255 })
      .notNull()
      .references(() => users.id, { onDelete: "cascade" }),
    createdAt: timestamp("created_at").defaultNow().notNull(),
    updatedAt: timestamp("updated_at").defaultNow().notNull(),
  },
  (table) => [
    unique("external_user_link_source_unique").on(table.partnerName, table.externalId),
    unique("external_user_link_user_unique").on(table.partnerName, table.userId),
    index("external_user_link_user_idx").on(table.userId),
  ],
)
